// extracted by mini-css-extract-plugin
export default {"childWrapper":"Confetti_childWrapper__WKKeq","confettiHolder":"Confetti_confettiHolder__0VEZp"};